import { StandardEvents } from '@shopify/events';

class FreeShippingProgress extends HTMLElement {
  connectedCallback() {
    this.total = Number(this.dataset.total);
    this.currency = this.dataset.currency;
    this.render();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
    this.timer = window.setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    document.removeEventListener(StandardEvents.cartDiscountUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
    window.clearInterval(this.timer);
    this.request?.abort();
  }

  onCartUpdate = async (event) => {
    try {
      if (event.promise) await event.promise;
      if (this.isConnected) await this.refresh();
    } catch (error) {
      if (error.name !== 'AbortError') this.render();
    }
  };

  onPageShow = (event) => {
    if (event.persisted) this.refresh().catch(() => this.render());
  };

  async refresh() {
    this.request?.abort();
    const request = new AbortController();
    this.request = request;
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', { signal: request.signal, cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    this.total = cart.total_price;
    this.currency = cart.currency;
    this.render();
  }

  render() {
    const message = this.querySelector('.free-shipping-progress__message');
    const track = this.querySelector('.free-shipping-progress__track');
    const fill = this.querySelector('.free-shipping-progress__fill');
    if (!message || !track || !fill) return;
    const start = Number(this.dataset.promoStart) * 1000;
    const end = Number(this.dataset.promoEnd) * 1000;
    const now = Date.now();
    const promo = this.dataset.promoEnabled === 'true' && this.dataset.promoMessage?.trim() &&
      Number.isFinite(start) && Number.isFinite(end) && start > 0 && end > start && now >= start && now < end + 1000;
    const threshold = Math.max(1, Number(this.dataset.threshold) || 10000);
    const total = Math.max(0, Number(this.total) || 0);
    const remaining = Math.max(0, threshold - total);
    const progress = promo ? 100 : Math.min(100, total / threshold * 100);
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: 'USD',
    }).format(remaining / 100);
    const text = promo ? this.dataset.promoMessage : this.currency !== 'USD' ?
      this.dataset.internationalMessage : remaining > 0 ?
        this.dataset.remainingMessage.replace('__AMOUNT__', amount) : this.dataset.unlockedMessage;
    if (message.textContent.trim() !== text) message.textContent = text;
    track.hidden = !promo && this.currency !== 'USD';
    track.setAttribute('aria-valuenow', String(Math.round(progress)));
    fill.style.setProperty('--free-shipping-progress', progress + '%');
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}


class ShippingCostNote extends HTMLElement {
  connectedCallback() {
    this.render();
    this.timer = window.setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  render() {
    const start = Number(this.dataset.promoStart) * 1000;
    const end = Number(this.dataset.promoEnd) * 1000;
    const now = Date.now();
    const active = this.dataset.promoEnabled === 'true' && this.dataset.promoMessage?.trim() &&
      start > 0 && end > start && now >= start && now < end + 1000;
    const promo = this.querySelector('[data-promo-note]');
    const standard = this.querySelector('[data-standard-note]');
    if (promo) promo.hidden = !active;
    if (standard) standard.hidden = Boolean(active);
  }
}

if (!customElements.get('shipping-cost-note')) {
  customElements.define('shipping-cost-note', ShippingCostNote);
}
